import {
  CREATENEWENQUIRES,
  GETNEWENQUIRES,
  UPDATENEWENQUIRES,
  DELETENEWENQUIRES,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATENEWENQUIRES:
      return {
        ...state,
        newenquiresSaveStatus: action.payload.success,
      };
    case GETNEWENQUIRES:
      return {
        ...state,
        newenquiresList: action.payload.data,
      };
    case UPDATENEWENQUIRES:
      return {
        ...state,
        newenquiresUpdateStatus: action.payload.success,
      };

    case DELETENEWENQUIRES:
      return {
        ...state,
        newenquiresDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
